import React from 'react'

import Container from '../Container/Container'

const PaymentComplete: React.FC = (): React.ReactElement => {
  return (
    <Container>
      <h1>Payment Complete</h1>
      <p>Thank you for your payment! </p>
      <p>
        A receipt will be emailed to the billing email address on file once
        funds have been received.
      </p>
    </Container>
  )
}

export default PaymentComplete
